import { Link } from 'react-router-dom';
import { WORKSPACE_SECTIONS, findSection } from '../../lib/nav-config';
import './section-nav.css';

/**
 * SectionNav — V98-3-1. The pages of the current nav section as one link
 * row (e.g. Evidence · Requests to you · Register · Common controls ·
 * Audit log). This is how pages that left the sidebar when the Classic /
 * Lifecycle navs were retired stay one click from their parent — no
 * orphan pages. Renders nothing outside a section or for a one-link one.
 */
export function SectionNav({ prefix, relativePath }: { prefix: string; relativePath: string }) {
  const hit = findSection(relativePath);
  if (!hit) return null;
  const links = WORKSPACE_SECTIONS[hit.sectionId] ?? [];
  if (links.length < 2) return null;
  return (
    <nav className="gp-section-nav" aria-label="In this section">
      <ul>
        {links.map((l) => (
          <li key={l.id}>
            <Link to={`${prefix}/${l.href}`} aria-current={l.id === hit.linkId ? 'page' : undefined}>
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
